import { createFileRoute } from "@tanstack/react-router";
import { LOCALE_FAQ } from "@/data/faq/locale-copy";
import { buildLocaleFaqHead } from "@/lib/faq/locale-head";
import { LocaleFaqPage } from "@/components/faq/LocaleFaqPage";

export const Route = createFileRoute("/zh/faq")({
  loader: () => ({ h: buildLocaleFaqHead("zh", LOCALE_FAQ.zh) }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <LocaleFaqPage copy={LOCALE_FAQ.zh} />,
});
